const galleryRegistry = new WeakMap();

function getMainViewport(root) {
  return root?.classList?.contains('carousel__viewport')
    ? root
    : root?.querySelector('.carousel__viewport');
}

function attachGalleryRoot(root, viewport) {
  if (!root || !viewport?.carousel) return;
  root.carousel = viewport.carousel;
  root._emblaApi = viewport._emblaApi;
}

function destroyGalleryRoot(root) {
  const viewport = getMainViewport(root);
  if (viewport) {
    window.ThemeCarousel.destroy(viewport);
  }
  delete root?.carousel;
  delete root?._emblaApi;
  galleryRegistry.delete(root);
}

function handleMainSelect(mainRoot, mainEmbla, subRoot, subEmbla) {
  window.pauseAllMedia?.();

  if (mainRoot?.carousel) {
    mainRoot.carousel.params.noSwiping = false;
  }

  const activeSlide = mainEmbla.slideNodes()[mainEmbla.selectedScrollSnap()];
  if (activeSlide?.querySelector('model-viewer')) {
    activeSlide
      .querySelector('.shopify-model-viewer-ui__button--poster')
      ?.removeAttribute('hidden');
  }

  if (subEmbla && subRoot) {
    subEmbla.scrollTo(mainEmbla.selectedScrollSnap());
    subRoot
      .querySelectorAll('.carousel__slide')
      .forEach((slide, index) => {
        slide.classList.toggle(
          'is-selected',
          index === mainEmbla.selectedScrollSnap(),
        );
      });
  }
}

function handleModelViewerDrag(mainRoot, mainEmbla) {
  const activeSlide = mainEmbla.slideNodes()[mainEmbla.selectedScrollSnap()];
  const modelViewer = activeSlide?.querySelector('model-viewer');
  if (
    modelViewer &&
    !modelViewer.classList.contains('shopify-model-viewer-ui__disabled')
  ) {
    if (mainRoot?.carousel) {
      mainRoot.carousel.params.noSwiping = true;
    }
    mainEmbla.reInit({ watchDrag: false });
    return;
  }

  mainEmbla.reInit({ watchDrag: true });
}

function getSublistAxisOptions() {
  return {
    axis: 'x',
    align: 'start',
    containScroll: 'trimSnaps',
    dragFree: false,
    watchDrag: false,
  };
}

const sliderInit = (isUpdate) => {
  document.querySelectorAll('.js-media-list').forEach((root, index) => {
    destroyGalleryRoot(root);

    const viewport = getMainViewport(root);
    if (!viewport) return;

    const subRoot = document.querySelectorAll('.js-media-sublist')[index];
    const subViewport = subRoot ? getMainViewport(subRoot) : null;
    const subEmbla = subViewport?._emblaApi || null;

    const wrapper = root.closest('.product__media-list-wrapper');
    const prevBtn = root.querySelector('.swiper-btn--prev, .carousel-btn--prev');
    const nextBtn = root.querySelector('.swiper-btn--next, .carousel-btn--next');

    const mainEmbla = window.ThemeCarousel.create(
      viewport,
      { loop: false, align: 'start' },
      [],
      {
        prev: prevBtn,
        next: nextBtn,
        onInit: (emblaApi) => {
          root.classList.add('is-initialized');
          attachGalleryRoot(root, viewport);

          emblaApi.on('select', () => {
            const subEmbla = subRoot?._emblaApi;
            handleMainSelect(root, emblaApi, subRoot, subEmbla);
          });

          emblaApi.on('pointerDown', () => {
            if (root.carousel?.params?.noSwiping) {
              emblaApi.reInit({ watchDrag: false });
            }
          });

          viewport.addEventListener('pointerup', () => {
            handleModelViewerDrag(root, emblaApi);
          });

          handleMainSelect(root, emblaApi, subRoot, subEmbla);
        },
      },
    );

    galleryRegistry.set(root, { mainEmbla, subRoot });

    if (isUpdate && mainEmbla) {
      setTimeout(() => mainEmbla.reInit(), 800);
    }
  });
};

const subSliderInit = (isUpdate) => {
  document.querySelectorAll('.js-media-sublist').forEach((root, index) => {
    destroyGalleryRoot(root);

    const viewport = getMainViewport(root);
    if (!viewport) return;

    const mainRoot = document.querySelectorAll('.js-media-list')[index];
    const mainViewport = mainRoot ? getMainViewport(mainRoot) : null;

    const subEmbla = window.ThemeCarousel.create(
      viewport,
      {
        loop: false,
        ...getSublistAxisOptions(),
      },
      [],
      {
        onInit: (emblaApi) => {
          root.classList.add('is-initialized');
          attachGalleryRoot(root, viewport);

          if (window.matchMedia('(min-width: 1100px)').matches) {
            const container = viewport.querySelector('.carousel__container');
            if (container && container.scrollHeight > 586) {
              root.classList.add('delimiter');
            } else {
              root.classList.remove('delimiter');
            }
          }

          emblaApi.slideNodes().forEach((slide, slideIndex) => {
            slide.addEventListener('click', () => {
              const mainEmbla = mainViewport?._emblaApi;
              if (mainEmbla) {
                mainEmbla.scrollTo(slideIndex);
              }
            });
          });

          emblaApi.on('select', () => {
            const mainEmbla = mainViewport?._emblaApi;
            if (mainEmbla) {
              mainEmbla.scrollTo(emblaApi.selectedScrollSnap());
            }
          });
        },
      },
    );

    if (isUpdate && subEmbla) {
      setTimeout(() => subEmbla.reInit(getSublistAxisOptions()), 800);
    }
  });
};

function getSliderSettings() {
  return { loop: false, align: 'start' };
}

function getSubSliderProductSettings() {
  return getSublistAxisOptions();
}

window.sliderInit = sliderInit;
window.subSliderInit = subSliderInit;
window.getSliderSettings = getSliderSettings;
window.getSubSliderProductSettings = getSubSliderProductSettings;

window.addEventListener('resize', () => {
  document.querySelectorAll('.js-media-sublist').forEach((root) => {
    const viewport = getMainViewport(root);
    const embla = viewport?._emblaApi;
    if (embla) {
      embla.reInit(getSublistAxisOptions());
    }
  });
});
